import { initSubRoutes } from '../../utils/router';

const RoutesPubliquesMentionsLegales = initSubRoutes({
    route: '/mentions-legales',
    subroutes: {},
    nom: 'Mentions légales',
});

export default RoutesPubliquesMentionsLegales;
